import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  Checkbox,
  TextField,
  Divider,
  Chip,
  Grid,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const SubmitWU = ({ open, onClose, transactionName }) => {
  const policyDetails = {
    policyNumber: 'POL-2024-001',
    insured: 'John Smith',
    effectiveDate: '2024-02-01'
  };

  const [selectedFiles, setSelectedFiles] = useState([
    { id: 1, name: 'Auto Insurance Application.pdf', selected: true },
    { id: 2, name: 'PAC Form.pdf', selected: true },
    { id: 3, name: 'Void Cheque.pdf', selected: true },
    { id: 4, name: 'AB Form.pdf', selected: true },
    { id: 5, name: 'Electronic Signature Consent.pdf', selected: true },
    { 
      id: 6, 
      name: 'Document Review Summary Report.pdf', 
      selected: true,
      required: true,
      systemGenerated: true,
      generatedDate: new Date().toLocaleDateString(),
      status: 'Auto Generated'
    }
  ]);
  
  const [remarks, setRemarks] = useState('');

  const handleToggleFile = (fileId) => {
    const file = selectedFiles.find(f => f.id === fileId);
    if (file.required) return;
    setSelectedFiles(files =>
      files.map(file =>
        file.id === fileId ? { ...file, selected: !file.selected } : file
      )
    );
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        pb: 1
      }}>
        <Typography variant="h6">
          Submit to Underwriter
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        {/* Policy Details Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Policy Details
          </Typography>
          <Box sx={{ 
            bgcolor: 'background.paper',
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            p: 2
          }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="caption" color="text.secondary">
                  Policy Number
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {policyDetails.policyNumber}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="caption" color="text.secondary">
                  Insured
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {policyDetails.insured}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="caption" color="text.secondary">
                  Effective Date
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {policyDetails.effectiveDate}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* Document List */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Documents to Submit
          </Typography>
          <List sx={{ 
            bgcolor: 'background.paper',
            border: '1px solid #e0e0e0',
            borderRadius: 1
          }}>
            {selectedFiles.map((file, index) => (
              <React.Fragment key={file.id}>
                <ListItem
                  sx={{
                    py: 1.5,
                    px: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    backgroundColor: file.required ? 'rgba(25, 118, 210, 0.04)' : 'inherit',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                    <Checkbox
                      checked={file.selected}
                      onChange={() => handleToggleFile(file.id)}
                      disabled={file.required}
                    />
                    <Box>
                      <Typography variant="body1" sx={{ fontWeight: file.required ? 500 : 400 }}>
                        {file.name}
                      </Typography>
                      {file.systemGenerated && (
                        <Typography variant="caption" color="text.secondary">
                          Generated on {file.generatedDate}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  {file.required && (
                    <Chip 
                      label={file.status}
                      size="small"
                      sx={{ 
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                        color: '#1565c0',
                        fontWeight: 500
                      }}
                    />
                  )}
                </ListItem>
                {index < selectedFiles.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </Box>

        {/* Remarks Section */}
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Remarks for Underwriter
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Add any notes or special instructions..."
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            sx={{ 
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#fff'
              }
            }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button 
          variant="contained"
          onClick={() => {
            console.log('Submitting:', selectedFiles.filter(f => f.selected));
            onClose();
          }}
          disabled={!selectedFiles.some(file => file.selected)}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitWU; 